module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av337-e028dbd2cc3d1cd14aa02eb61a27bf98.jpg";